// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1J8PI","content":"RecentSearches_content__2PHV_"};